import { render, staticRenderFns } from "./DeleteOverlay.vue?vue&type=template&id=7f1373ff&"
import script from "./DeleteOverlay.js?vue&type=script&lang=js&"
export * from "./DeleteOverlay.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/develop.mijnmooiestraat.vlaanderen/pro-develop.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f1373ff')) {
      api.createRecord('7f1373ff', component.options)
    } else {
      api.reload('7f1373ff', component.options)
    }
    module.hot.accept("./DeleteOverlay.vue?vue&type=template&id=7f1373ff&", function () {
      api.rerender('7f1373ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/DeleteOverlay/DeleteOverlay.vue"
export default component.exports